import Loadable from 'components/Loadable';
import { lazy } from 'react';
import { RouteObject } from 'react-router';

const Index = Loadable(lazy(() => import('./index')));
const Form = Loadable(lazy(() => import('./form/index')));

export const routes: RouteObject[] = [
    {
        path: '/laporan/registrasi-nasabah',
        element: <Index />
    },
    {
        path: '/form/laporan/registrasi-nasabah/:id',
        element: <Form />,
    },
];
